import React from 'react';
import { Card, Tabs } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import BasePage from 'components/page/BasePage';
import Debug from '../components/Debug';

const DebugPage: React.FC = () => {
  const tabItems = [
    {
      key: 'debug',
      label: 'contents',
      children: <Debug />,
    },
  ];

  return (
    <BasePage>
      <div style={{ padding: '24px' }}>
        <Card
          title={
            <span>
              <BugOutlined style={{ marginRight: 8 }} />
              Debug menu
            </span>
          }
          style={{ minHeight: 'calc(100vh - 200px)' }}
        >
          <Tabs defaultActiveKey="debug" size="large" items={tabItems} />
        </Card>
      </div>
    </BasePage>
  );
};

export default DebugPage;

